export default __webpack_public_path__ + "static/media/topicalNote_sample.106e1ae7.jpg";